import { bigNumberToNumberUNSAFE } from '@lyra/core/utils/bigNumberToNumberUNSAFE'
import useSWR from 'swr'
import { Address } from 'viem'

import { PARTNER_VAULTS, PartnerVaultId } from '../constants/partnerVaults'
import { collateralConfig } from '../constants/tokens'
import useAuth from './useAuth'

type PartnerVaultStats = {
  id: PartnerVaultId
  totalSupply: number
  tvl: number
  balance: number
}

const fetcher = async (ownerAddress?: Address): Promise<PartnerVaultStats[]> => {
  return await Promise.all(
    Object.values(PARTNER_VAULTS).map(async (vault) => {
      const [balance, totalSupply] = await Promise.all([
        ownerAddress ? vault.getBalance(ownerAddress) : BigInt(0),
        vault.getTotalSupply(),
      ])

      const dps = collateralConfig[vault.collateralId].decimals
      const totalSupplyNum = bigNumberToNumberUNSAFE(totalSupply, dps)
      const balanceNum = bigNumberToNumberUNSAFE(balance, dps)

      return {
        id: vault.id,
        totalSupply: totalSupplyNum,
        tvl: totalSupplyNum,
        balance: balanceNum,
      }
    })
  )
}

export function usePartnerVaultStats() {
  const { user } = useAuth()
  const ownerAddress = user?.ownerAddress
  return useSWR(['PartnerVaults', ownerAddress], () => fetcher(ownerAddress))
}
